/** Extra tooltip lines: attack damage (blue, Bedrock style) and durability when damaged. */
import { itemDef, maxDamageOf } from '../game/itemdb';
import type { Stack } from '../game/types';
import { I } from '../game/itemIds';
import { spearTier } from '../game/spear';

export function statTooltipLines(s: Stack): string[] {
  const out: string[] = [];
  const tool = itemDef(s.id).tool;
  if (tool && tool.attack > 0) out.push(`§9+${Number.isInteger(tool.attack) ? tool.attack : tool.attack.toFixed(1)} Attack Damage`);
  const sp = spearTier(s.id);
  if (sp) out.push(`§9${sp.speed} Jab Speed`, `§9x${sp.chargeMult} Charge Damage`);
  if (s.id === I.FIREWORK_ROCKET) {
    out.push(`§7Flight Duration: ${Math.min(3, Math.max(1, s.fw?.[0] ?? 1))}`);
    const n = Math.max(0, (s.fw?.length ?? 1) - 1);
    if (n > 0) out.push(`§7${n} explosion${n > 1 ? 's' : ''}`);
  }
  if (s.id === I.FIREWORK_STAR && s.fw) out.push(`§7#${s.fw[0].toString(16).padStart(6, '0')}`);
  const max = maxDamageOf(s.id);
  if (max > 0 && s.dmg > 0) out.push(`Durability: ${max - s.dmg} / ${max}`);
  return out;
}
